import { Box } from '@mui/system';
import { Chip, CircularProgress, Typography } from '@mui/material';
import { MessageStatus } from 'bloggers-backend/lib/aiagents/domain';
import { Bubble } from './Bubble';

const STATUS_COLOR: Record<MessageStatus, 'info' | 'success' | 'error' | 'warning'> = {
  'in progress': 'info',
  done: 'success',
  error: 'error',
  interrupted: 'warning',
};

export function PendingBubble() {
  return (
    <Bubble isUser={false}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <CircularProgress size={16} />
        <Typography color="text.secondary">in progress…</Typography>
      </Box>
    </Bubble>
  );
}

export function ErrorBubble({ error }: { error?: string }) {
  return (
    <Bubble isUser={false}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
        <Chip size="small" label="error" color={STATUS_COLOR.error} sx={{ alignSelf: 'flex-start' }} />
        <Typography color="error" sx={{ whiteSpace: 'pre-wrap' }}>
          {error}
        </Typography>
      </Box>
    </Bubble>
  );
}
